import Vue from 'vue'

import PageLayout from '@/layouts/PageLayout'
import PopUpLayout from '@/layouts/PopUpLayout'
import SectionLayout from '@/layouts/SectionLayout'
import CustomDialog from '@/components/generic/popups/CustomDialog'
import PopUpSeguro from '@/components/generic/popups/PopUpSeguro'
import OBigTitle from '@/components/generic/titulos/OBigTitle'
import OMediumTitle from '@/components/generic/titulos/OMediumTitle'
import OExpandTitle from '@/components/generic/titulos/OExpandTitle'
import ODescriptionTitle from '@/components/generic/titulos/ODescriptionTitle'
import OMainProgress from '@/components/generic/OMainProgress'
import OBtnVolver from '@/components/generic/OBtnVolver'
import OSelectTable from '@/components/generic/inputs/OSelectTable'
import ODatePicker from '@/components/generic/inputs/ODatePicker'
import ONumericTextField from '@/components/generic/ONumericTextField'
import NumericTextField from '@/components/generic/NumericTextField'
import FileUploader from '@/components/generic/inputs/fileUploader/FileUploader'

Vue.component('page-layout', PageLayout)
Vue.component('pop-up-layout', PopUpLayout)
Vue.component('section-layout', SectionLayout)
Vue.component('custom-dialog', CustomDialog)
Vue.component('pop-up-seguro', PopUpSeguro)
Vue.component('o-big-title', OBigTitle)
Vue.component('o-medium-title', OMediumTitle)
Vue.component('o-expand-title', OExpandTitle)
Vue.component('o-description-title', ODescriptionTitle)
Vue.component('o-main-progress', OMainProgress)
Vue.component('o-btn-volver', OBtnVolver)
Vue.component('o-select-table', OSelectTable)
Vue.component('o-date-picker', ODatePicker)
Vue.component('v-numeric-text-field', NumericTextField)
Vue.component('o-numeric-text-field', ONumericTextField)
Vue.component('o-file-uploader', FileUploader)
